import { render, staticRenderFns } from "./EmployerDetail.vue?vue&type=template&id=2826c62f"
import script from "./EmployerDetail.vue?vue&type=script&lang=js"
export * from "./EmployerDetail.vue?vue&type=script&lang=js"
import style0 from "./EmployerDetail.vue?vue&type=style&index=0&id=2826c62f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports